import styleInject from '../../util/injectCss.js';

var css_248z = ".ModalFooter__ouLBf_v2 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 2.5rem; }\n";
var styles = {"ModalFooter":"ModalFooter__ouLBf_v2"};
styleInject(css_248z);

export { styles as default };
